import * as PlaylistConstants from './constants';

export function getAndAddReplayTrack(data) {
  return {
    type: PlaylistConstants.ActionKeys.GET_AND_ADD_REPLAY_TRACK,
    data,
  };
}

export function insertTrackIntoPlaylist({
  playlist,
  index,
  currentTrackToken,
  trackToken,
  audioFormat,
}) {
  return {
    type: PlaylistConstants.ActionKeys.INSERT_TRACK_INTO_PLAYLIST,
    data: {
      playlist,
      index,
      currentTrackToken,
      trackToken,
      audioFormat,
    },
  };
}

export default {
  insertTrackIntoPlaylist,
  getAndAddReplayTrack,
};
